import styled from "styled-components";
import { device } from "../../../../utils/utils";

export const Ftr = styled.footer`
  background: linear-gradient(90deg, #0B1B29 -380.41%, #554176 100%);
  height: 70px;
  @media ${device.mobileS} {
    height: 36px;
  }
`;
export const FtrWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  position: relative;
  @media ${device.mobileS} {
    width: 100%;
  }
`;
export const FtrBtnArrow = styled.a`
  width: 121px;
  position: absolute;
  right: -55px;
  top: -24px;
  cursor: pointer;
  @media ${device.mobileS} {
    right: 0;
  }
`;